// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, object, string } from 'prop-types'

import {
  OpenInNewTab,
  PassiveTrigger,
  PathMenu,
} from './common'

// RE: LEGO-5254
// See components/DataTable/Row for details on
// what's happening here with event handling.

class PathInfo extends React.Component {
  static propTypes = {
    columnKey: string.isRequired,
    customProps: object.isRequired,
    idRoot: string.isRequired,
    rowData: object.isRequired,
    TooltipTrigger: func.isRequired,
  }

  state = {
    mouseDownX: null,
    mouseDownY: null,
  }

  pathIndexStyle = { width: '30px' }

  handleClick = e => {
    const {
      clientX,
      clientY,
    } = e

    const {
      customProps,
      rowData,
    } = this.props

    const {
      highlightRows,
      rowHighlightToggle,
    } = customProps

    // if we're not supposed to highlight rows,
    // let the click event bubble up.
    if (!highlightRows) {
      return e
    } else {
      e.stopPropagation()
    }

    const {
      mouseDownX,
      mouseDownY,
    } = this.state

    this.setState(() => ({
      mouseDownX: null,
      mouseDownY: null,
    }))

    // This component is used as a child of that and we need to manage event
    // propagation/bubbling between these two.
    if (
      Math.abs(mouseDownX - clientX) < 10 &&
      Math.abs(mouseDownY - clientY) < 10
    ) {
      const uniqueValue = rowData[rowData.uniqueId]
      return rowHighlightToggle(uniqueValue)
    }
  }

  // capture coordinates for where the user fired mousedown
  handleMouseDown = ({ clientX, clientY }) => (
    this.setState(() => ({
      mouseDownX: clientX,
      mouseDownY: clientY,
    }))
  )

  render () {
    const {
      customProps,
      columnKey,
      idRoot,
      rowData,
      TooltipTrigger,
    } = this.props

    const {
      renderOpenInNewTab,
      renderPathMenu,
    } = customProps

    const {
      band,
      passiveSummary,
      pathId,
      pathIndex,
      pathName,
      rcnNumber,
    } = rowData

    return (
      <div
        className={'path-summary-path-info-cell path-summary-cell'}
        onClick={this.handleClick}
        onMouseDown={this.handleMouseDown}
        title={`Path Id: ${pathId}`}>
        <div className={'path-summary-site-cell'}>
          <span
            data-label={'path-index'}
            id={`${idRoot}-path-index`}
            style={this.pathIndexStyle}>{pathIndex}</span>
          <strong
            className={'text-ellipsis margin-right-auto'}
            data-label={'path-name'}
            id={`${idRoot}-path-name`}>
            {pathName}
          </strong>
          <span
            data-label={'path-band'}
            id={`${idRoot}-path-band`}>
            {band}
          </span>
        </div>
        <div className={'path-summary-site-cell'}>
          {
            renderPathMenu &&
            <PathMenu
              idRoot={`${idRoot}-path-menu-`}
              pathId={pathId} />
          }
          {
            renderOpenInNewTab &&
            <OpenInNewTab
              idRoot={idRoot}
              newPath={`/database-management/path/${pathId}`} />
          }
          <span
            className={'text-ellipsis margin-right-auto'}
            data-label={'path-rcn'}
            id={`${idRoot}-path-rcn`}>
            {rcnNumber}
          </span>
          <PassiveTrigger
            columnKey={columnKey}
            idRoot={idRoot}
            passiveSummary={passiveSummary}
            TooltipTrigger={TooltipTrigger} />
        </div>
      </div>
    )
  }
}

export default PathInfo
